import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import IotMainBlockData from '../../../Models/Content/IotMainBlockData';
import MainIot from './MainIot';

export default class IotMainBlock extends EpiComponent<IotMainBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainIot iContent={this.props.data} context={this.getContext()} />;
  }
}
